/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios, { baseURL } from "utils/api";
import { toast } from "react-toastify";

const useSupportTicketCategoryData = (handleDeleteClick, handleEditClick, refresh, searchQuery) => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [filteredCategories, setFilteredCategories] = useState([]);

  const columns = [
    { name: "sno", align: "center" },
    { name: "Category", align: "center" },
    { name: "action", align: "center" },
  ];

  useEffect(() => {
    axios
      .get(`${baseURL}/support-ticket-categories?limit=100`)
      .then((res) => {
        if (res.data.success) {
          const data = res.data.data;
          const activeCategories = data.filter((categoryItem) => !categoryItem.isDeleted);

          // Apply search filter
          const filtered = searchQuery
            ? activeCategories.filter((cat) =>
                cat.name?.toLowerCase().includes(searchQuery.toLowerCase())
              )
            : activeCategories;

          setFilteredCategories(filtered);
          setFilteredCategories(filtered);
          setCount(filtered.length);

          if (filtered.length === 0) {
            setRows([]);
          } else {
            const formattedRows = filtered.map((item, index) => ({
              sno: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {index + 1}
                </ArgonTypography>
              ),
              Category: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {item.name}
                </ArgonTypography>
              ),
              action: (
                <ArgonBox display="flex" alignItems="center" gap={0}>
                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "12px", p: 0 }}
                    onClick={() => handleEditClick(item._id, item.name)}
                  >
                    <EditIcon color="warning" />
                  </ArgonButton>
                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "32px", p: 0 }}
                    onClick={() => handleDeleteClick(item._id)}
                  >
                    <DeleteIcon color="error" />
                  </ArgonButton>
                </ArgonBox>
              ),
            }));

            setRows(formattedRows);
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching support ticket categories:", err);
        const backendError = err.response?.data?.message;
        if (backendError) toast.error(backendError);
      });
  }, [refresh, searchQuery]);

  return { columns, rows, count, filteredCategories };
};

export default useSupportTicketCategoryData;
